/* @flow */
// typecheck: ignore file
import React from 'react';
import cx from 'classnames';

import './styles/Overlay.scss';

type Props = {
  children?: any,
  className?: string,
};

function Overlay(props: Props) {
  return (
    <div className={cx('Overlay', props.className)}>
      {props.children}
    </div>
  );
}

export default Overlay;



// WEBPACK FOOTER //
// ./src/components/Overlay.jsx